import {Routes, Route} from 'react-router-dom';
import GradientDescent from './GradientDescent';
import MachineLearningIntro from "./MachineLearningIntro";
import SupervisedLearningRoutes from "./SupervisedLearning/SupervisedLearningRoutes";
import UnsupervisedLearningRoutes from "./UnsupervisedLearning/UnsupervisedLearningRoutes";
import ReinforcedLearningRoutes from "./ReinforcedLearning/ReinforcedLearningRoutes";
import CostFunctionRoutes from "./CostFunction/CostFunctionRoutes";

const MachineLearningRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<MachineLearningIntro/>}/>
                <Route path="/gradient-descent" element={<GradientDescent/>}/>
                <Route path="/supervised-learning/*" element={<SupervisedLearningRoutes/>}/>
                <Route path="/unsupervised-learning/*" element={<UnsupervisedLearningRoutes/>}/>
                <Route path="/reinforced-learning/*" element={<ReinforcedLearningRoutes/>}/>
                <Route path="/cost-function/*" element={<CostFunctionRoutes/>}/>

            </Routes>
        </>
    )
}

export default MachineLearningRoutes;